<template>
  <v-data-table
    :headers="visualizarPontosMedalha ? headers : headersSemPontos"
    :items="perguntasRejeitadas"
    class="elevation-1"
    hide-default-footer
    :expanded.sync="expanded"
    disable-pagination
    item-key="perguntaMunicipioId"
  >
    <template v-slot:item="props">
      <tr>
        <td>{{ props.item.nome }}</td>
        <td :title="props.item.faixaNome">
          {{ diminuirValue(props.item.faixaNome) }}
        </td>

        <td>
          <div>
            <div>{{ props.item.texto }}</div>
          </div>
        </td>
        <td
          @click="() => $emit('openEvidence', props.item)"
          v-if="props.item.temArquivo"
        >
          <div class="optionsExpanded">
            <v-btn
              color="azulclarosc"
              class="ml-3"
              style="color: #fff"
              v-if="
                isFullAdmin ||
                (groupsConfig.visualizarRejeitadas &&
                  config.visualizarRejeitadas)
              "
            >
              <span
                v-if="
                  expanded.length > 0 &&
                  props.item.perguntaMunicipioId ===
                    expanded[0].perguntaMunicipioId
                "
                >esconder arquivos</span
              >
              <span v-else>mostrar arquivos</span>
            </v-btn>
          </div>
        </td>
        <td v-else></td>
        <td v-if="!isSala">{{ props.item.pontos }}</td>
        <td width="300px">
          <template v-if="props.item.qtdRejeicao >= 2">
            <div>
              O Critério foi rejeitado duas vezes e não poderá ser submetido a
              uma nova avaliação.
            </div>
          </template>
          <template v-else-if="!prazoReenvioMaior(props.item.prazoReenvio)">
            <div>
              Prazo para envio de novo arquivo encerrou no dia
              {{ prazoReenvio(props.item.prazoReenvio) }} às 23:59
            </div>
          </template>

          <template v-else>
            <template
              v-if="
                isFullAdmin ||
                !isSala ||
                (isSala &&
                  JSON.parse(config.visualizaEixosIds || '[]').includes(
                    props.item.eixoId
                  ) &&
                  groupsConfig.enviarRejeitadas &&
                  config.enviarRejeitadas)
              "
            >
              <v-file-input
                accept="application/pdf, application/vnd.ms-excel"
                label="Selecione Arquivos de Evidência"
                v-model="props.item.arquivos"
              >
              </v-file-input>
            </template>
          </template>
        </td>
        <td>
          <template
            v-if="
              (!props.item.qtdRejeicao || props.item.qtdRejeicao < 2) &&
              prazoReenvioMaior(props.item.prazoReenvio)
            "
          >
            <template
              v-if="
                isFullAdmin ||
                !isSala ||
                (isSala &&
                  JSON.parse(config.visualizaEixosIds || '[]').includes(
                    props.item.eixoId
                  ) &&
                  groupsConfig.enviarRejeitadas &&
                  config.enviarRejeitadas)
              "
            >
              <v-btn
                color="primary"
                class="ml-3"
                @click="checkCarregar(props.item)"
              >
                <span v-if="isSala">Carregar</span>
                <span v-else>Enviar</span>
              </v-btn>
            </template>
          </template>
        </td>
        <td v-if="props.item.evidencia">
          <app-modal-show-evidence
            :evidence="props.item.evidencia"
            :color="'primary'"
            :isHtml="isSala ? true : false"
          >
          </app-modal-show-evidence>
        </td>
        <td v-else></td>
        <td v-if="props.item.temArquivo">
          <div class="hasEvidence"></div>
        </td>
        <td v-if="!props.item.temArquivo">
          <div class="hasNoEvidence"></div>
        </td>
        <td v-if="isFullAdmin || user.grupo.nome == 'Operações'">
          <v-btn color="info" @click="perguntaReverterAnalise(props.item)"
            >Reverter Análise</v-btn
          >
        </td>
      </tr>
    </template>
    <template v-slot:expanded-item="props">
      <tr class="complemento" v-if="evidences && evidences.length > 0">
        <td colspan="8" class="evidencias">
          <app-get-evidence-question
            :perguntaId="props.item.perguntaMunicipioId"
            @updateValue="$emit('updateValue')"
            :evidences="evidences"
            :type="'Evidenciadas'"
            :readonly="true"
            @loadEvidence="
              $emit('loadEvidence');
              $emit('load');
            "
          ></app-get-evidence-question>
        </td>
      </tr>
      <tr
        class="complemento"
        v-if="props.item.perguntaId == 3 && evidences && evidences.length > 0"
      >
        <td colspan="8">
          <h1 class="titulo">Dados complementares obrigatórios</h1>
          <div>
            <div class="d-flex perguntas">
              <div class="_nome">
                Mínimo de horas por atendente informado no(s) arquivo(s)
                carregados acima
                <span v-if="!isParceiro"
                  >(incluindo as 04 horas mínimas de capacitação em Compras
                  Governamentais)
                </span>
              </div>
              <div>
                <v-text-field
                  label=""
                  type="number"
                  v-model="props.item.valorInformado"
                  outlined
                  placeholder="0"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>
            <hr />
            <div class="d-flex perguntas">
              <div class="_nome">
                Quantidade de atendentes informada no
                <strong>diagnóstico</strong>
              </div>
              <div>
                <v-text-field
                  label=""
                  type="number"
                  v-model="valorDiagnostico"
                  outlined
                  disabled
                  placeholder="0"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>
            <hr />
            <div class="d-flex perguntas">
              <div class="_nome">Quantidade atual de atendentes</div>
              <div>
                <v-text-field
                  label=""
                  type="number"
                  v-model="props.item.atualizacaoAtendentes"
                  outlined
                  placeholder="0"
                  hide-details="auto"
                ></v-text-field>
              </div>
            </div>
            <template>
              <hr />
              <div class="d-flex perguntas">
                <div class="_nome">
                  <div>Declaração de alteração obrigatória se:</div>
                  <div>
                    Houve mudança na quantidade de atendentes OU A quantidade
                    foi mantida mas houve alteração do nome dos
                    atendentes responsáveis
                  </div>
                </div>
                <div>
                  <v-file-input
                    accept="application/pdf, application/vnd.ms-excel"
                    :rules="rulesArquivo"
                    style="width: 300px"
                    label="Selecione o arquivo"
                    v-model="props.item.arquivosDados"
                    placeholder="Selecione o arquivo"
                    hide-details="auto"
                    outlined
                  >
                  </v-file-input>
                </div>
              </div>
            </template>
          </div>
        </td>
      </tr>
      <template
        v-if="
          isFullAdmin ||
          (groupsConfig.enviarRejeitadas && config.enviarRejeitadas)
        "
      >
        <tr
          class="complemento"
          v-if="
            (props.item.perguntaId !== 3 ? props.item.temArquivo : true) &&
            evidences &&
            evidences.length &&
            evidences.find((item) => !item.enviada)
          "
        >
          <td colspan="8">
            <div class="d-flex" style="justify-content: flex-end">
              <v-btn
                color="primary"
                class="ml-3"
                @click="checkSalvarDados(props.item)"
              >
                <span>Salvar</span>
              </v-btn>
              <v-btn
                color="azulclarosc"
                class="ml-3"
                style="color: #fff"
                @click="checarForm(props.item)"
              >
                <span>Salvar e enviar para análise</span>
              </v-btn>
            </div>
          </td>
        </tr>
      </template>
    </template>
    <template slot="no-data">
      <span> Nenhuma pergunta retornada </span>
    </template>
  </v-data-table>
</template>
<script>
import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";
import { mapActions, mapGetters } from "vuex";
import AppGetEvidenceQuestion from "@/modules/evidence/components/selo/GetQuestionSelo";
import { cityQuestionAPI } from "@/modules/city";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import Swal from "sweetalert2";
import { rulesFile } from "../utils";
import moment from "moment-timezone";

export default {
  components: {
    AppModalShowEvidence,
    AppGetEvidenceQuestion,
  },
  props: {
    visualizarPontosMedalha: { type: Boolean, required: true },
    perguntasRejeitadas: { type: Array, required: true },
    headers: { type: Array, required: true },
    headersSemPontos: { type: Array, required: true },
    payload: { type: Object, Array: true },
    rulesArquivo: { type: Array, required: true },
    expanded: { type: Array, required: true },
    evidences: { type: Array },
  },
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      visualizarComplemento: false,
      valorDiagnostico: 0,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    diminuirValue(item) {
      if (item && item.length > 50) {
        return item.substring(0, 50) + "...";
      }

      return item;
    },
    perguntaReverterAnalise(pergunta) {
      Swal.fire({
        title: "Reverter Análise!",
        text: `Ao reverter a análise, o prazo de reenvio será descontinuado e as evidências retornarão a fase de análise. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.reveterAnalise(pergunta);
        }
      });
    },
    reveterAnalise(pergunta) {
      this.setLoading(true);
      cityQuestionAPI
        .revertarAnalise(pergunta.perguntaMunicipioId)
        .then((resp) => {
          this.$emit("updateValue");
        })
        .catch((err) => {
          console.log("Error on rejeitadaselo reveteranalise");
          this.setLoading(false);
          this.$notification.error("Erro em reverter analise");
        });
    },
    checkCarregar(pergunta) {
      const pdfRules = rulesFile(
        pergunta.perguntaId,
        pergunta.quantidadeArquivo,
        pergunta.quantidadeArquivoDadosComplementares,
        this.valorDiagnostico,
        pergunta.atualizacaoAtendentes
      );

      if (!pergunta.arquivos || pergunta.arquivos.length == 0) {
        this.$notification.error("Não há evidências a serem enviadas!");
        return;
      } else if (pdfRules) {
        this.$notification.error(pdfRules);
      } else {
        pergunta.perguntaId == 3
          ? this.$emit("sendEvidences", pergunta, false, true)
          : this.$emit("sendEvidences", pergunta, false, false);
      }
    },
    prazoReenvio(prazoReenvio) {
      return moment(prazoReenvio, "YYYY-MM-DD")
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY");
    },
    checkSalvarDados(pergunta) {
      if (pergunta.arquivosDados) {
        this.setLoading(true);
        cityQuestionAPI
          .getPergunta(pergunta.perguntaMunicipioId)
          .then((resp) => {
            pergunta.evidence = resp.data.evidencias;

            if (
              pergunta.arquivosDados &&
              pergunta.evidence.find(
                (item) =>
                  item.nomeArquivo.includes("DADOS_COMPLE_") && !item.rejeitada
              )
            ) {
              Swal.fire({
                title: "Arquivo já existente",
                html: `
            Já existe um arquivo de dados complementares associado a essa pergunta.
            <div style="margin: 15px 0">Caso queira modifica-lo, poderá excluí-lo na seção <strong>Evidências</strong> acima de Dados Complementares.</div>
             <div>Arquivos de dados complementares começam por <strong>DADOS_COMPLE </strong></div>`,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
              });
              this.setLoading(false);
              return;
            } else {
              this.$emit("sendEvidences", pergunta, false, true);
            }
          })
          .catch(() => {
            this.setLoading(false);
            this.$notification.error("Erro ao obter pergunta");
          });
      } else {
        this.$emit("sendEvidences", pergunta, false, true);
      }
    },
    perguntaAnalise(pergunta) {
      Swal.fire({
        title: "Enviar a análise!",
        text: `Ao enviar a análise só poderá ser alterada em caso de rejeição. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("enviarAnalise", pergunta);
        }
      });
    },
    checarForm(pergunta) {
      this.setLoading(true);
      cityQuestionAPI
        .getPergunta(pergunta.perguntaMunicipioId)
        .then((resp) => {
          pergunta.evidence = resp.data.evidencias;

          let hasArquivoDados =
            pergunta.evidence.find((item) =>
              item.nomeArquivo.includes("DADOS_COMPLE_")
            ) || pergunta.arquivosDados;

          let hasArquivos =
            pergunta.evidence.find(
              (item) => !item.nomeArquivo.includes("DADOS_COMPLE_")
            ) || pergunta.arquivos.length > 0;

          if (
            pergunta.valorInformado &&
            pergunta.atualizacaoAtendentes &&
            !!hasArquivoDados &&
            !!hasArquivos &&
            pergunta.perguntaId == 3
          ) {
            this.verComplemento = false;
            this.perguntaAnalise(pergunta);
          } else if (
            (!pergunta.valorInformado ||
              !pergunta.atualizacaoAtendentes ||
              (!hasArquivoDados &&
                this.valorDiagnostico != pergunta.atualizacaoAtendentes) ||
              !hasArquivos) &&
            pergunta.perguntaId == 3
          ) {
            Swal.fire({
              title: "Campos obrigatórios",
              html: `
            ${
              !pergunta.valorInformado
                ? '<div style="margin-top:20px">Mínimo de horas por atendente é obrigatório</div>'
                : ""
            }
            ${
              !pergunta.atualizacaoAtendentes
                ? '<div style="margin-top:20px">Quantidade atual de atendentes é obrigatória</div>'
                : ""
            }
            ${
              !hasArquivoDados &&
              this.valorDiagnostico != pergunta.atualizacaoAtendentes
                ? `<div style="margin-top:20px">Arquivo de declaração da alteração da quantidade de atendentes é obrigatório</div>`
                : ""
            }
             ${
               !hasArquivos
                 ? '<div style="margin-top:20px">É necessário ao menos uma evidência</div>'
                 : ""
             }
            `,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            });
            this.setLoading(false);
          } else if (!hasArquivos && pergunta.perguntaId != 3) {
            Swal.fire({
              title: "Campos obrigatórios",
              html: `
             ${
               !hasArquivos
                 ? '<div style="margin-top:20px">É necessário ao menos uma evidência</div>'
                 : ""
             }
            `,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            });
            this.setLoading(false);
          } else {
            this.verComplemento = false;
            this.perguntaAnalise(pergunta);
          }
        })
        .catch(() => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    getRespostaDiagnostico() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .getRespostaPergunta(this.isParceiro ? 106 : 133, this.$route.params.id)
        .then((resp) => {
          this.valorDiagnostico = resp.data && resp.data[0].resposta;
        });
      this.setLoading(false);
    },
    prazoReenvioMaior(prazoReenvio) {
      let dayAtual = moment(moment(), "YYYY-MM-DD")
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .tz("America/Sao_Paulo");

      let prazo = moment(prazoReenvio, "YYYY-MM-DD").set({
        hour: 23,
        minute: 59,
      });

      return prazo.isAfter(dayAtual);
    },
  },
  mounted() {
    this.getRespostaDiagnostico();
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
      "isSala",
      "isAnalista",
      "isFullAdmin",
      "isParceiro",
    ]),
  },
};
</script>
<style>
.complemento .v-input__control {
  background: #fff;
}

.pergunta3 .v-file-input__text {
  color: #fff !important;
}
.pergunta3 .v-text-field .v-label {
  color: #f5f5f5 !important;
}
</style>
<style scoped lang="scss">
.evidencias {
  padding: 10px 30px !important;
  .titulo2 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .nomeEvidencia {
    cursor: pointer;
    color: #2d6189;
    font-weight: bold;
  }

  .nomeEvidencia:not(:last-of-type) {
    border-right: 1px solid #dfdfdf;
    padding-right: 20px;
  }

  .agrupEvidencias {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 20px;
  }
}

.pergunta3 {
  background: #2d6189;
  color: #fff;
}
.pergunta3:hover {
  background: #3d6788 !important;
  color: #fff;
}
.complemento {
  background: #f5f5f5;
}
.complemento td {
  padding: 10px 30px !important;
}
.titulo {
  font-size: 20px;
  margin: 1rem 0;
}
.perguntas {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;

  ._nome {
    max-width: 70%;
  }
}
</style>
